import { takeLatest, all, call, put } from 'redux-saga/effects';
import { openSnackbar } from '../snackbar';
import { getCoordinateDeviceDetails, getCoordinateDevices, getCoordinatePackets } from 'utils/apis/maps';
import {
    completeMapDataFetch,
    completeMapPacketHistoryFetch,
    setMapData,
    setMapDetailsError,
    setMapListError,
    setMapPacketHistory,
    setSelectedDevice,
    startMapData,
    startMapPacketHistory
} from './mapSlice';

function* mapDevicesResponseHandler() {
    try {
        const response = yield call(getCoordinateDevices);
        yield put(setMapData(response?.devices || []));
        yield put(setMapListError(''));
        yield put(completeMapDataFetch());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(setMapListError(error.message || 'Unable to load GaiaPod devices.'));
        yield put(completeMapDataFetch());
    }
}

function* startMapDevicesWatcher() {
    yield takeLatest(startMapData.type, mapDevicesResponseHandler);
}

function* mapPacketHistoryResponseHandler({ payload }) {
    try {
        const [deviceDetails, packetsResponse] = yield all([
            call(getCoordinateDeviceDetails, payload),
            call(getCoordinatePackets, payload)
        ]);

        if (deviceDetails) {
            yield put(setSelectedDevice(deviceDetails));
        }

        yield put(setMapPacketHistory(packetsResponse?.packets || []));
        yield put(setMapDetailsError(''));
        yield put(completeMapPacketHistoryFetch());
    } catch (error) {
        yield put(
            openSnackbar({
                open: true,
                message: error.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: false,
                actionButton: false
            })
        );
        yield put(setMapDetailsError(error.message || 'Unable to load GaiaPod tracking history.'));
        yield put(completeMapPacketHistoryFetch());
    }
}

function* startMapPacketHistoryWatcher() {
    yield takeLatest(startMapPacketHistory.type, mapPacketHistoryResponseHandler);
}

export default function* mapsSaga() {
    yield all([call(startMapDevicesWatcher), call(startMapPacketHistoryWatcher)]);
}
